import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f97a2c10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "city" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_map" }
const _hoisted_4 = { class: "map_1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "popover_community_city_map" }
const _hoisted_7 = {
  key: 0,
  class: "l"
}
const _hoisted_8 = {
  key: 1,
  class: "qr"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 扫码添加小助手，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 回复“"),
  /*#__PURE__*/_createElementVNode("span", null, "城市大使"),
  /*#__PURE__*/_createTextVNode("”"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 申请成为城市大使。 ")
], -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "box_text" }
const _hoisted_14 = { class: "box_text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_click" }, " 点击申请成为城市大使 ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 社区城市管理者 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 社区开发者来自北京、上海、广州、深圳、杭州、青岛等城市，欢迎申请成为城市管理员。 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "",
            src: $data.file.ImageMap_1
          }, null, 8 /* PROPS */, _hoisted_5),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.mapList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["box_position", [{max:item.name.length>2,leader:item.leader},`i_${index+1}`]]),
              style: _normalizeStyle({top:`${item.y}%`,left:`${item.x}%`})
            }, [
              _createTextVNode(_toDisplayString(item.name) + " ", 1 /* TEXT */),
              _createVNode(_component_a_popover, { trigger: "hover" }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_typography_title, { level: 5 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    (item.leader)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createTextVNode(" 负责人："),
                          _createElementVNode("span", null, _toDisplayString(item.leader), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ], 6 /* CLASS, STYLE */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _createElementVNode("img", {
          class: "map_2",
          alt: "",
          src: $data.file.ImageMap_2
        }, null, 8 /* PROPS */, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode(" 你能得到什么？ ")
          ]),
          _: 1 /* STABLE */
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.getList, (item) => {
          return (_openBlock(), _createElementBlock("p", null, _toDisplayString(item), 1 /* TEXT */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode(" 你需要做些什么？ ")
          ]),
          _: 1 /* STABLE */
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.doList, (item) => {
          return (_openBlock(), _createElementBlock("p", null, _toDisplayString(item), 1 /* TEXT */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _hoisted_15,
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$Store.Page().openModal('modalQR', 'cityAmbassador')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 点击申请 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}